import * as React from "react";
import { ChevronLeft, ChevronRight, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

const MONTH_LABELS = Array.from({ length: 12 }, (_, i) =>
  new Date(2000, i, 1).toLocaleDateString(undefined, { month: "short" })
);

const BTN_NAV =
  "h-7 w-7 bg-slate-800 hover:bg-slate-700 rounded-lg flex items-center justify-center text-slate-400 hover:text-white transition-colors flex-shrink-0";

export function MonthPicker({ calMonth, setCalMonth, setView, selectedDate }) {
  const year = calMonth.getFullYear();
  const today = new Date();
  return (
    <div className="p-3 w-[252px]">
      <div className="flex items-center justify-between mb-3 px-1">
        <button
          type="button"
          onClick={() => setCalMonth(new Date(year - 1, calMonth.getMonth(), 1))}
          className={BTN_NAV}
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={() => setView("years")}
          title="Click to browse by year"
          className="flex items-center gap-1 text-sm font-semibold text-white hover:text-[#4d8aff] px-2 py-0.5 rounded-lg hover:bg-slate-700/60 transition-colors"
        >
          {year}
          <ChevronDown className="h-3 w-3 opacity-50" />
        </button>
        <button
          type="button"
          onClick={() => setCalMonth(new Date(year + 1, calMonth.getMonth(), 1))}
          className={BTN_NAV}
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
      <div className="grid grid-cols-3 gap-1.5">
        {MONTH_LABELS.map((label, i) => {
          const isSel =
            selectedDate && selectedDate.getFullYear() === year && selectedDate.getMonth() === i;
          const isTod = today.getFullYear() === year && today.getMonth() === i;
          return (
            <button
              key={i}
              type="button"
              onClick={() => {
                setCalMonth(new Date(year, i, 1));
                setView("days");
              }}
              className={cn(
                "py-2 rounded-lg text-sm font-medium transition-all",
                isSel
                  ? "bg-altiv-navy text-white"
                  : isTod
                    ? "bg-slate-700 text-white"
                    : "text-slate-300 hover:bg-slate-700 hover:text-white"
              )}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
